import { AlertCircle } from 'lucide-react';

interface FullscreenWarningModalProps {
  show: boolean;
  countdown: number;
  onGoBack: () => void;
}

function FullscreenWarningModal({ show, countdown, onGoBack }: FullscreenWarningModalProps) {
  if (!show) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black bg-opacity-75 backdrop-blur-sm" />

      <div className="relative bg-white rounded-lg shadow-2xl p-8 max-w-md w-full mx-4 animate-[fadeIn_0.2s_ease-in-out]">
        <div className="flex flex-col items-center text-center">
          <div className="bg-red-100 rounded-full p-4 mb-4">
            <AlertCircle className="w-16 h-16 text-red-600" />
          </div>

          <h2 className="text-2xl font-bold text-gray-900 mb-2">
            Fullscreen Mode Required
          </h2>

          <div className="mb-6">
            <p className="text-gray-700 mb-4">
              You have exited fullscreen mode. Please return to fullscreen immediately.
            </p>
            <div className="bg-red-50 border-2 border-red-200 rounded-lg p-4">
              <p className="text-red-800 font-semibold">
                Your exam will be closed in:
              </p>
              <div className="text-5xl font-bold text-red-600 mt-2">
                {countdown}
              </div>
              <p className="text-red-700 text-sm mt-2">
                seconds
              </p>
            </div>
          </div>

          <button
            onClick={onGoBack}
            className="w-full px-6 py-3 bg-cyan-600 text-white rounded-lg font-bold hover:bg-cyan-700 transition-colors shadow-lg"
          >
            GO BACK TO TEST
          </button>

          <p className="text-gray-500 text-xs mt-4">
            Your answers will be automatically submitted if you don't return to fullscreen
          </p>
        </div>
      </div>
    </div>
  );
}

export default FullscreenWarningModal;
